import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { FormattedMessage, defineMessages } from 'react-intl'
import { Button, Text } from 'src/Components'
import { TeaserEmailSvg, TeaserAppSvg, TeaserTextSvg } from './svgs'

import CheckBoxSvg from './CheckBoxSvg'
import styles from './TeaserWindow.module.scss'

export const svgMessages = defineMessages({
  email: {
    id: 'Homeowner.teasers.notification.platform.email',
    defaultMessage: 'Email'
  },
  app: {
    id: 'Homeowner.teasers.notification.platform.app',
    defaultMessage: 'App'
  },
  text: {
    id: 'Homeowner.teasers.notification.platform.text',
    defaultMessage: 'Text'
  }
})

const NotificationPlatformPrompt = ({ handleChange, handleNext }) => (
  <>
    <Text size='l' align='center'>
      <FormattedMessage
        id='Homeowner.teasers.notification.platform.title'
        defaultMessage='How do you want to receive your Homebot notifications?'
      />
    </Text>
    <div className={styles.checkboxes}>
      <div className={classnames(styles.subset, styles.locked)}>
        <CheckBoxSvg
          keyName='email'
          defaultValue
          icon={TeaserEmailSvg}
          locked
        />
      </div>
      <div className={classnames(styles.subset, styles.comingSoon)}>
        <Text
          element='div'
          size='xxs'
          weight='semibold'
          className={styles.headerTab}
        >
          <FormattedMessage
            id='Homeowner.teasers.notification.platform.comingSoon'
            defaultMessage='Coming Soon'
          />
        </Text>
        <CheckBoxSvg
          keyName='app'
          defaultValue={false}
          icon={TeaserAppSvg}
          onChange={handleChange}
        />
        <CheckBoxSvg
          keyName='text'
          defaultValue={false}
          icon={TeaserTextSvg}
          onChange={handleChange}
        />
      </div>
    </div>
    <Button primary fullWidth onClick={handleNext}>
      <FormattedMessage id='General.buttons.save' defaultMessage='Save' />
    </Button>
  </>
)

NotificationPlatformPrompt.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired
}

export default NotificationPlatformPrompt
